import React from 'react'
import PropTypes from 'prop-types'

import BasePriceWithDiscount from './BasePriceWithDiscount'
import calculateOrderSummaryPrices from './calculateOrderSummaryPrices'

const priceLabelClassName = 'priceLabelWithDiscountOrderSummary'
const priceClassName = 'priceOrderSummary'
const discountBoxClassName = 'discountBox'
const discountLabelClassName = 'discountLabel'
const mainBoxDirection = 'column'

const OrderSummaryPrice = ({ fullPriceInfo, qty, enableUSBAddon, showEachSuffix }) => {
  const { finalPrice, discountLabel, price } = calculateOrderSummaryPrices({
    fullPriceInfo,
    qty,
    enableUSBAddon,
    showEachSuffix,
  })
  const discountMethod = fullPriceInfo.promo_discount_details?.discount_method

  return (
    <BasePriceWithDiscount
      finalPrice={finalPrice}
      price={price}
      discountLabel={discountLabel}
      discountMethod={discountMethod}
      priceLabelClassName={priceLabelClassName}
      priceClassName={priceClassName}
      discountBoxClassName={discountBoxClassName}
      discountLabelClassName={discountLabelClassName}
      mainBoxDirection={mainBoxDirection}
    />
  )
}

OrderSummaryPrice.propTypes = {
  fullPriceInfo: PropTypes.object.isRequired,
  qty: PropTypes.number,
  enableUSBAddon: PropTypes.bool,
  showEachSuffix: PropTypes.bool,
}

export default OrderSummaryPrice
